let _collections_conf = {
  SocketMessage: {
      primary_key: {
          name: 'uuid',
          autoIncrement: false
      },
      props:{
          /*uuid:{
              indice:{
                  unique: true
              },
              type: 'string',
              required: true
          },*/
          from: {
              indice:{
                  compound: ["id", "name", "user_id", "agency_id"]
              },
              type: {},
              required: true
          },
          to: {
              indice:{
                  compound: ["id", "name", "user_id", "agency_id"]
              },
              type: {},
              required: true
          },
          agency_id: {
              indice:{
                  unique: false
              },
              type: 'number',
              required: true
          },
          type: {
              indice:{
                  unique: false
              },
              type: 'string',
              required: true
          },
          sent: {
              indice:{
                  unique: false
              },
              type: 'number',
              required: true
          },
          ttl: {
              indice:{
                  unique: false
              },
              type: 'date',
              required: true
          },
          createdAt: {
              indice:{
                  unique: false
              },
              type: 'date',
              required: true
          },
          updatedAt: {
              indice:{
                  unique: false
              },
              type: 'date',
              required: true
          },
          channel: {
              indice:{
                  unique: false
              },
              type: 'string',
              required: true
          },
          read: {
              type: [],
              required: true
          },
          people: {
              type: [],
              required: true
          },
          subject: {
              indice:{
                  unique: false
              },
              type: 'string',
              required: true
          },
          message: {
              indice:{
                  unique: false
              },
              type: 'string',
              required: true
          },
          data: {
              type: {},
              required: false
          },
          items: {
              type: [],
              required: false
          },
          __v: {
              type: 'number',
              required: true
          }
      }
  },
  // other collection here
  channels: {
      primary_key: {
          name: 'local_id',
          autoIncrement: true
      },
      props:{
          uuid:{
              indice:{
                  unique: true
              },
              type: 'string',
              required: true
          },
          name: {
              indice:{
                  unique: true
              },
              type: 'string',
              required: true
          },
          messages: {
              indice:{
                  compound: ["uuid"]
              },
              type: [],
              required: true
          },
          __v: {
              type: 'number',
              required: true
          }
      }
  }
}

export function setConf (conf) {
  _collections_conf = conf
}
export function getConf () {
  return _collections_conf
}







// WEBPACK FOOTER //
// ./src/helpers/mediator/eDB/collections_conf.js